import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about", id: "nav-about-link" },
  { label: "Services", href: "#services", id: "nav-services-link" },
  { label: "Pricing", href: "#pricing", id: "nav-pricing-link" },
  { label: "Process", href: "#process", id: "nav-process-link" },
  { label: "FAQ", href: "#faq", id: "nav-faq-link" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[70px] flex items-center justify-between">
        <a href="#home" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt="Purpose Haul Dispatch"
            className="h-10 w-auto invert transition-transform duration-500 group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-get-dispatched-button"
            className="font-mono text-[11px] uppercase tracking-[0.25em] bg-white text-black px-5 py-2.5 hover:bg-neutral-300 transition-colors duration-300"
          >
            Get Dispatched
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden border-t border-white/10 bg-[#0B0B0B]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`${l.id}-mobile`}
                  onClick={() => setOpen(false)}
                  className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-300"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#contact"
                data-testid="nav-get-dispatched-button-mobile"
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.25em] bg-white text-black px-5 py-3 text-center"
              >
                Get Dispatched
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
